import AudienceImportView from '../influencerTable/InfluencerTableViewModal'
import {
  InfluencerBody,
  InfluencerData,
} from '../../../core/interface/chronique.interface'

interface Props {
  data: InfluencerData[]
  onClose: () => void
  onValidate: (selectedData: InfluencerBody[]) => void
  loading: boolean
}

const ImportedAudienceTable = ({
  data,
  onClose,
  onValidate,
  loading,
}: Props) => {
  const handleValidate = (selectedUsers: InfluencerData[]) => {
    const selectedInfluencers: InfluencerBody[] = selectedUsers.map((user) => ({
      userid: user.influencer.userid,
      affinity: user.affinity,
    }))
    onValidate(selectedInfluencers)
  }

  return (
    <AudienceImportView
      open
      onClose={onClose}
      data={data}
      onValidate={handleValidate}
      loading={loading}
    />
  )
}

export default ImportedAudienceTable
